import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="flex items-center justify-center w-20 h-20 bg-muted rounded-full mb-6">
          <Icon name="Search" size={40} className="text-muted-foreground" />
        </div>
        <h3 className="text-2xl font-heading font-semibold text-foreground mb-3">
          No Newsletters Found
        </h3>
        <p className="text-muted-foreground max-w-md mb-6">
          We couldn't find any newsletters matching your current filters. Try adjusting your search criteria or clearing filters to see all available editions.
        </p>
        <Button
          variant="default"
          size="default"
          onClick={onClearFilters}
          iconName="RotateCcw"
          iconPosition="left"
          iconSize={18}
        >
          Clear All Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="flex items-center justify-center w-20 h-20 bg-muted rounded-full mb-6">
        <Icon name="FileText" size={40} className="text-muted-foreground" />
      </div>
      <h3 className="text-2xl font-heading font-semibold text-foreground mb-3">
        No Newsletters Available
      </h3>
      <p className="text-muted-foreground max-w-md">
        There are currently no newsletter editions in the archive. Check back soon for new content and updates.
      </p>
    </div>
  );
};

export default EmptyState;